import React from 'react'
import styled from '@emotion/styled'

const Root = styled.div`
  display: block;
  width: 18px;
  height: 18px;
  cursor: pointer;

  svg {
    max-width: 100%;
    max-height: 100%;
  }
    
  rect {
    fill: ${props => props.active ? '#5bad5e' : '#47494c'}
  }
`

const IconButton = ({svgIcon, active, handleClick}) => <Root active={active} onClick={handleClick}>
  {svgIcon}
</Root>

export default IconButton
